const socket = {
  namespaced: true,

  state: {
    socketMsg: '',
    loginHandleMsg: ''

  },

  mutations: {
    SOCKET_MSG: (state, msg) => {
      state.socketMsg = msg
    },
    LOGIN_HANFLE: (state, msg) => {
      state.loginHandleMsg = msg
    }

  },

  actions: {
    socket({ commit }, msg) {
      commit('SOCKET_MSG', msg)
    },
    loginHandle({ commit }, msg) {
      commit('LOGIN_HANFLE', msg)
    }
  }
}

export default socket



// WEBPACK FOOTER //
// ./src/store/modules/socket.js